import React from "react";

function NonCompliedSvgComponent(props: any) {
  return (
    <div>
      <svg
        id="thumb_down_off_alt_black_24dp"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g id="Group_9772" data-name="Group 9772">
          <rect
            id="Rectangle_16540"
            data-name="Rectangle 16540"
            width="24"
            height="24"
            fill="none"
          />
        </g>
        <g id="Group_9774" data-name="Group 9774">
          <g id="Group_9773" data-name="Group 9773">
            <path
              id="Path_40254"
              data-name="Path 40254"
              d="M15,3H6A1.987,1.987,0,0,0,4.16,4.22L1.14,11.27A1.976,1.976,0,0,0,1,12v2a2.006,2.006,0,0,0,2,2H9.31l-.95,4.57-.03.32a1.505,1.505,0,0,0,.44,1.06L9.83,23l6.59-6.59A1.987,1.987,0,0,0,17,15V5A2.006,2.006,0,0,0,15,3Zm0,12-4.34,4.34L12,14H3V12L6,5h9ZM19,3h4V15H19Z"
              fill="#dc7768"
            />
          </g>
        </g>
      </svg>
    </div>
  );
}

export default NonCompliedSvgComponent;
